import { parseFrontmatter } from './utils';
import type { BlogPost } from '../types/blog';
import type { Project } from '../types/project';

// Load all blog posts
const blogModules = import.meta.glob('../content/blog/*.md', {
  query: '?raw',
  eager: true
});

export async function getAllBlogPosts(): Promise<BlogPost[]> {
  const posts = await Promise.all(
    Object.entries(blogModules).map(async ([path, module]) => {
      const content = module as string;
      const { data, content: markdown } = parseFrontmatter(content);
      return {
        ...data,
        content: markdown,
        path
      } as unknown as BlogPost;
    })
  );
  return posts.sort((a: BlogPost, b: BlogPost) =>
    new Date(b.date).getTime() - new Date(a.date).getTime()
  );
}

export async function getBlogPostBySlug(slug: string): Promise<BlogPost | undefined> {
  const posts = await getAllBlogPosts();
  return posts.find(post => post.slug === slug);
}

// Load all projects
const projectModules = import.meta.glob('../content/projects/*.md', {
  query: '?raw',
  eager: true
});

export async function getAllProjects(): Promise<Project[]> {
  const projects = await Promise.all(
    Object.entries(projectModules).map(async ([path, module]) => {
      const content = module as string;
      const { data, content: markdown } = parseFrontmatter(content);
      return {
        ...data,
        content: markdown,
        path
      } as unknown as Project;
    })
  );
  return projects;
}

export async function getProjectBySlug(slug: string): Promise<Project | undefined> {
  const projects = await getAllProjects();
  return projects.find(project => project.slug === slug);
}

export async function getFeaturedProjects(): Promise<Project[]> {
  const projects = await getAllProjects();
  return projects.filter(project => project.featured);
}
